/** Soft-login returns API names; lookup remaps. Normalize so form fields match. */
export function normalizeLookupCustomer(customer) {
  if (!customer) return customer;
  return {
    ...customer,
    emailAddress: customer.emailAddress ?? customer.email,
    streetName: customer.streetName ?? customer.address,
    mobilePhone: customer.mobilePhone ?? customer.mobilePhoneNumber,
  };
}

/** True when the field still holds the masked placeholder from lookup (not user input). */
export function isUnchangedMaskedValue(value, masked) {
  return Boolean(masked) && value === masked;
}
